<template>
  <div class="circle-tab-list" @touchmove.stop>
    <router-link 
      v-for="circle in circleUpdateList"
      :to="{
        name: 'circle',
        params: {
          id: circle.id
        }
      }"
    >
      <van-image 
        :src="$formatImg(circle.avatar, 360)"
        width="120"
        height="72"
        radius="8"
      />
      <p>{{ circle.name }}</p>
      <span>{{ $t('updates', circle.num) }} </span>
    </router-link>
    <div class="view-all" @click="visible = true">
      <svg-icon name="icon-back" />
      <span>{{ $t('viewAll') }}</span>
    </div>
  </div>
  <ThreadList :apiName="apiName" :options="options" :needSticky="true" @changeSort="changeSort"/>
  <ViewAllMyCircle v-model="visible" :dragList="dragList"></ViewAllMyCircle>
</template>

<script setup>

import ViewAllMyCircle from './viewAllMyCircle'
import ThreadList from './threadList'

const { proxy } = getCurrentInstance()

const props = defineProps({
  data: {
    type: Array,
  }
})

const apiName = ref('getMyCircleList')
const visible = ref(false)

const dragList = ref([])
const circleUpdateList = ref([])

const options = ref([{
  label: proxy.$t('latestCreated'),
  value: 1
}, {
  label: proxy.$t('latestActivity'),
  value: 2
}])

function changeSort ({value}) {
  apiName.value = value === 2 ? 'getMyCircleListRecent' : 'getMyCircleList'
}

watch(() => props.data, (val) => {
  if (val && val.length) {
    circleUpdateList.value = val.filter((i, index) => index < 8)
    dragList.value = val
  }
}, {
  immediate: true,
  deep: true
})

</script>
<style lang="postcss" scoped>
.circle-tab-list {
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100vw;
  padding: 20px 20px 16px;
  box-sizing: border-box;
  overflow: auto;

  &::-webkit-scrollbar {
    display: none;
  }
  a {
    display: flex;
    flex-flow: column wrap;
    justify-content: flex-start;
    width: 120px;
    margin-right: 8px;
    &:last-child {
      margin-right: 0;
    }
  }
  p {
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 100%;
    overflow: hidden;
    font-size: 14px;
    margin-top: 8px;
  }
  span {
    font-size: 12px;
    color: var(--text-secondary);
    margin-top: 4px;
  }
  .view-all {
    flex-shrink: 0;
    display: flex;
    flex-flow: column wrap;
    align-items: center;
    justify-content: center;
    width: 120px;
    height: 72px;
    background: var(--background-light);
    border-radius: 8px;
    .svg-icon {
      transform: rotate(180deg);
      color: var(--text-secondary);
    }
  }
}

</style>